<template>
    <div class="body-panel login-page-bg-old" @click="appElementClick" v-cloak>
        <div :class="['body-panel-control', { 'opened': menuMobShow }]">
            <div class="header-inner flex">
                <div v-if="isMobile" class="header-menu-mobile" @click="toggleMenuMob">
                    <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <use xlink:href="/Content/dist/images.svg#Toggler"></use>
                    </svg>
                </div>
                <div v-if="isMobile && info.User != null && hasClaims(info.User.DynamicRole, claimEnums.bonusSpend)" style="padding:16px 0">
                    <p class="user-info-ball">
                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <use xlink:href="/Content/dist/images.svg?#Balans"></use>
                        </svg>
                        <span>{{ getUserBonusToDisplay('active', true) }}</span> / <span>{{ getUserBonusToDisplay('potential', true) }}</span>

                    </p>
                </div>
                <!--                <div v-if="isMobile && info.User != null && (info.User.SalesPlan != null || info.User.SalesFact != null)" style="padding:16px 0 16px 20px;">
                              <p class="user-info-ball">
                                <span v-html="userPlanFactData.Display"></span>
                              </p>
                            </div>-->

                <div class="header-logo">
                    <img class="header-logo-img" :src="selectedProject.Image" v-if="selectedProject != null && selectedProject.Image != null" />
                </div>
                <div v-if="!isMobile" style="width:100%">

                </div>
                <div class="header-menu-right flex" v-if="!isMobile && info.User != null">
                    <notification  v-model="info.NotificationsLength" :menuColor="menuColor" :info="info"></notification>
                    <div class="user-logout" @click.stop="logOut()">
                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <use xlink:href="/Content/dist/images.svg?#Logout"></use>
                        </svg>
                        <span>Выйти</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="body-panel-content">
            <div class="flex page">
                <div class="page-menu" :class="{ 'opened': menuMobShow }" @click="toggleMenuMob">
                    <div class="user-info" v-if="info.User != null ">
                        <div class="user-icon">
                            <svg class="svg-icon" v-if="info.User.Image == null" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <use xlink:href="/Content/dist/image_svg.svg?#User2"></use>
                            </svg>
                            <img :src="info.User.Image" v-if="info.User.Image != null" />
                        </div>
                        <div class="user-data">
                            <p v-if="!info.User.LevelInProject" class="user-info-name margin-top-10">{{ getUserNameToDisplay() }}</p>
                            <div v-if="info.User.LevelInProject" class="user-info-ball margin-top-10 levelinproject">
                                <span>{{ getLevelName(info.User.LevelInProject) }}</span>
                                <div class="levelinproject-icon-size" :class="getLevelIconClass(info.User.LevelInProject)"></div>
                            </div>
                            <p class="user-info-ball margin-top-5" v-if="hasClaims(info.User.DynamicRole, claimEnums.bonusSpend)">
                                <span>{{ getUserBonusToDisplay('potential') }}</span>
                            </p>
                            <p class="user-info-ball margin-top-5" v-if="hasClaims(info.User.DynamicRole, claimEnums.bonusSpend)">
                                <!--<svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <use xlink:href="/Content/dist/images.svg?#Balans"></use>
            </svg>-->
                                <span>{{ getUserBonusToDisplay('active') }}</span>
                            </p>
                            <!--<p class="user-info-ball margin-top-5" style="position: relative;" v-if="info.User.SalesPlan != null || info.User.SalesFact != null">
            <span @mouseenter="onSpanEnter" @mouseleave="onSpanLeave" v-html="userPlanFactData.Display"></span>
            <transition name="fade">
              <div class="tooltip" v-if="showSpanDetails">
                <div class="tooltip-body" v-html="userPlanFactData.Tooltip"></div>
              </div>
            </transition>
        </p>-->
                        </div>
                    </div>
                    <div class="page-menu-items">
                        <side-menu :cartItemsCount="cartItemsCount" :collapsed="menuCollapsed" ref="menu" :info="info" v-if="info && info.Pages"
                                   :menuColor="menuColor"></side-menu>
                        <div class="user-exit" v-if="isMobile">
                            <div class="user-logout" @click.stop="logOut()">
                                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <use xlink:href="/Content/dist/images.svg?#Logout"></use>
                                </svg>
                            </div>
                        </div>
                        <div class="menu-item" v-if="info.User != null && info.User.MainRole === 'administrators'">
                            <a @click.stop="onShowModal('ppChangeUser')">
                                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:style="{fill: menuColor}">
                                    <use xlink:href="/Content/dist/images.svg#MenuProfile"></use>
                                </svg>
                                <span>Сменить пользователя</span>
                            </a>
                        </div>
                        <div class="menu-item comback" v-if="loggedByUser === true">
                            <a @click.stop="onReturnFromUser()">
                                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <use xlink:href="/Content/dist/images.svg#Logout"></use>
                                </svg>
                                <span>Вернуться</span>
                            </a>
                        </div>
                    </div>
                    <div class="stp-info" v-if="info.FeedbackSettings != null && (info.FeedbackSettings.PhoneSTP || info.FeedbackSettings.Email)">
                        <div class="form-field">
                            <label class="input-text-lbl">Техническая поддержка</label>
                            <div v-if="info.FeedbackSettings.PhoneSTP">
                                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:style="{fill: menuColor }">
                                    <use xlink:href="/Content/dist/image_svg.svg#Phone2"></use>
                                </svg>
                                <span>{{ info.FeedbackSettings.PhoneSTP }}</span>
                            </div>
                            <div v-if="info.FeedbackSettings.Email">
                                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:style="{fill: menuColor }">
                                    <use xlink:href="/Content/dist/images.svg?v3#MenuMail"></use>
                                </svg>
                                <span>{{ info.FeedbackSettings.Email }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page-content">
                    <div v-if="info.User != null && info.User.IsDisabled" class="error" style="color:#36586f;font-weight:600;background-color:#FFF;border-bottom:1px solid #eaebf0">
                        Ваш аккаунт отключен. Обменяйте баллы на призы
                        <template v-if="info.User.BlockedDateTime">
                            до {{formatDate(info.User.BlockedDateTime, 'DD.MM.YYYY HH:mm')}}
                        </template>.
                    </div>

                    <router-view v-if="info.User != null"
                                 @need-refresh-menu="refreshMenuData()"
                                 @need-refresh-cart="refreshCart()"
                                 @user-updated="userUpdated"
                                 :info="info"></router-view>
                </div>
            </div>
        </div>


        <popup-window ref="ppAgreements" :title="'Для работы в системе, пожалуйста, ознакомьтесь с политикой конфиденциальности и правилами программы'" width="80%" :modal="true">
            <div>
                <div class="form-field">
                    <input id="NotificationsEnabled1" v-model="NotificationsEnabled" value="true" type="checkbox" class="input-checkbox" />
                    <label for="NotificationsEnabled1" class="input-checkbox-lbl">Я хочу получать новости и оповещения по email и sms</label>
                </div>
                <div class="form-field">
                    <input id="TermsConfirmed1" v-model="TermsConfirmed" value="true" type="checkbox" class="input-checkbox" />
                    <label for="TermsConfirmed1" class="input-checkbox-lbl">
                        Я согласен с <a v-if="info.PolicyFile" href="javascript:;" @click.stop="onShowPolicyClick" style="color:#ff0000">политикой</a><span v-if="!info.PolicyFile">политикой</span>
                        конфиденциальности сервиса и <a v-if="info.RulesFile" href="javascript:;" @click.stop="onShowRulesClick" style="color:#ff0000">правилами программы</a>
                        <span v-if="!info.RulesFile">правилами программы</span>
                    </label>
                </div>
                <div class="form-field">
                    <input id="PersonalDataEditingAccept1" v-model="PersonalDataEditingAccept" value="true" type="checkbox" class="input-checkbox" />
                    <label for="PersonalDataEditingAccept1" class="input-checkbox-lbl">Я согласен на обработку персональных данных в соответствии с Федеральным законом N152-ФЗ</label>
                </div>
                <div class="btns flex">
                    <button type="button" class="btn btn-primary margin-top-15"
                            @click="saveAgreements()" v-if="TermsConfirmed && PersonalDataEditingAccept">
                        Сохранить
                    </button>
                </div>
            </div>
        </popup-window>

        <popup-window name="ppEmailConfirmed" ref="ppEmailConfirmed" :title="'Для продолжения работы требуется подтвердить email'" width="300px" :modal="true" key="ppEmailConfirmed">
            <div class="row">

                <div class="form-group" v-if="confirmation.state === 'init'">
                    <span>Email для подтверждения - <strong>{{confirmation.email}}</strong></span>
                    <div class="btns flex margin-top-10">
                        <button type="button" class="btn btn-primary" :disabled="confirmation.isSending" @click.stop="requestConfirmationCode">Отправить код</button>
                        <button type="button" class="btn btn-default" @click="onConfirmationShowNewEmail">Изменить email</button>
                    </div>
                </div>

                <div class="form-group" v-if="confirmation.state === 'code'">
                    <div class="form-field">
                        <label class="input-text-lbl">
                            Введите код
                        </label>
                        <input type="text" name="code"
                               :class="['input-text']"
                               v-model="confirmation.code.value"
                               @keyup="onConfirmationCodeKeyUp"
                               :disabled="confirmation.code.disabled" />
                        <span class="field-validation-valid">{{confirmation.errors.code}}</span>
                    </div>
                    <button type="button" class="btn btn-default" @click="confirmation.showInfoText = true">Код не пришёл</button>
                    <div v-if="confirmation.showInfoText === true" class="margin-top-10">
                        Вы проверили папку СПАМ?
                        <button type="button" class="btn btn-default" @click="onConfirmationShowNewEmail">Да, письма нет</button>
                    </div>
                </div>

                <div class="flex" v-if="confirmation.state === 'confirmed'">
                    <div class="test-result-body-icon">
                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <use xlink:href="/Content/dist/image_svg.svg#ResultOk"></use>
                        </svg>
                    </div>
                    <div class="test-result-body-text">
                        <p class="test-hello-text">Код подтверждён</p>
                    </div>
                </div>

                <div class="form-group" v-if="confirmation.state === 'newemail'">
                    <span>Email для подтверждения - <strong>{{confirmation.email}}</strong></span>
                    <div class="form-field margin-top-10">
                        <label class="input-text-lbl">
                            Введите новый email-адрес
                        </label>
                        <input type="text" name="newemail" :class="['input-text', {'input-error': errors.has('newemail', 'newemail')}]"
                               v-validate="'required|email'"
                               v-model="confirmation.newemail"
                               data-vv-scope="newemail" />

                        <span class="field-validation-valid">{{confirmation.errors.newemail}}</span>
                    </div>
                    <div class="btns flex">
                        <button type="button" class="btn btn-primary" data-vv-scope="newemail" @click.stop="onConfirmationNewEmailSave">Сохранить</button>
                        <button type="button" class="btn" @click.stop="confirmation.state = 'init'">Назад</button>
                    </div>
                </div>
            </div>
        </popup-window>


        <first-launch v-if="firstLaunchItemsShow"
                      :firstLaunchItems="firstLaunchItems"
                      @actions-complete="onActionsComplete">
        </first-launch>

        <popup-window ref="ppPolicy" :title="'Политика конфиденциальности сервиса'" :width="800" :height="'90%'">
            <p class="p-header-1"></p>
            <template v-if="info.PolicyFile">
                <iframe v-if="fileExtensionIsHtml(info.PolicyFile)" :src="info.PolicyFile"></iframe>
                <pdf-viewer v-else ref="pdfViewPolicy"></pdf-viewer>
            </template>
        </popup-window>

        <popup-window ref="ppRules" :title="'Правила программы'" :width="800" :height="'90%'">
            <p class="p-header-1"></p>
            <template v-if="info.RulesFile">
                <iframe v-if="fileExtensionIsHtml(info.RulesFile)" src="info.RulesFile"></iframe>
                <pdf-viewer v-else ref="pdfViewRules"></pdf-viewer>
            </template>
        </popup-window>

        <popup-window ref="ppChangeUser" :title="'Смена пользователя'">
            <div class="form-field">
                <input class="input-text" name="UserId" placeholder="Введите Id пользователя" type="text"
                       v-model="userToChange.id"
                       @keyup="onUserIdChange"
                       :class="['input-text']" />
                <div class="margin-top-5 error" v-if="userToChange.found === false">Пользователь не найден</div>
                <div class="margin-top-10" v-if="userToChange.found === true">
                    <strong>{{userToChange.fio}}</strong>
                </div>
            </div>
            <div class="form-actions">
                <div class="form-btns">
                    <button type="button" class="btn btn-primary"
                            @click="onChangeUser()" :disabled="!userToChange.id || userToChange.found !== true">
                        Сменить
                    </button>
                </div>
            </div>
        </popup-window>

        <!--<popup-window ref="ppChangeUserProject" :title="'Смена проекта'" :height="300">
        <div class="form-field margin-right-10">
            <drop-down
                       :items="info.Projects"
                       :dataField="'Id'"
                       :textField="'ProjectName'"
                       v-model="newProjectId"
                       :cssClass="'margin-right-10'"></drop-down>
        </div>
        <div class="form-actions">
            <div class="form-btns" style="float: right;">
                <button type="button" class="btn btn-primary"
                        @click="onUserProjectChange()">
                    Сменить
                </button>
            </div>
        </div>
    </popup-window>-->

    </div>
</template>

<script>
    import $ from 'jquery'
    import SideMenu from './SideMenu'
    import BackendApi from '../../backendApi'
    import cart from '../../cart'
    import config from '../../config'
    import UI from '../../helpers/ui-helpers'
    import CM from '../../helpers/common-mixin'
    import '../../../img/image_svg.svg'
    import '../../../img/images.svg'
    import _ from 'lodash'
    import {UserLevelCode} from "../../enums";

    let backendApi = new BackendApi();
    let tokenKey = "tokenInfo";

    export default {
        name: "layout",

        props: ['appMenuCollapsed'],

        components: {
            SideMenu
        },

        watch: {
            '$route'(to, from) {
                this.loadSummary();
                this.saveSecondsProgress();
                this.totalSeconds = 0;
            }
        },

        data() {
            return {
                profileMenuOpen: false,
                menuCollapsed: false,
                menuMobShow: false,
                info: {
                    User: null
                },
                cartItemsCount: 0,
                selectedProject: null, // todo: можно поставить здесь дефолтный
                about: {
                    isEditing: false,
                    text: '',
                    origin: ''
                },
                firstLaunchItems: null,
                firstLaunchItemsShow: false,
                NotificationsEnabled: null,
                TermsConfirmed: null,
                PersonalDataEditingAccept: null,

                loggedByUser: false,
                userToChange: {
                    fio: null,
                    id: null,
                    redirectUrl: null,
                    found: null
                },
                confirmation: {
                    state: 'init', // init,code,confirmed,newemail
                    email: null,
                    newemail: null,
                    errors: {
                        code: null,
                        newemail: null
                    },
                    code: {
                        disabled: false,
                        value: null
                    },
                    showInfoText: false,
                    isSending: false
                },
                totalSeconds: 0,
                layoutActive: true,
                newProjectId: null,
                isMobile: UI.check_mobile(),
                //showSpanDetails: false
                menuColor: '',
            }
        },

        computed:{
            UserLevelCode() {
              return UserLevelCode
            },
            /*userPlanFactData(){
              let display = [], tooltip = [], donePercent = null;
              if(this.info.User.SalesPlan != null){
                display.push(this.formatInt(this.info.User.SalesPlan.toFixed(0)) + ' руб.');
                tooltip.push('План: ' + this.formatInt(this.info.User.SalesPlan) + ' руб.');
              }
              if(this.info.User.SalesFact != null){
                display.push(this.formatInt(this.info.User.SalesFact.toFixed(0)) + ' руб.');
                tooltip.push('Продано: ' + this.formatInt(this.info.User.SalesFact) + ' руб.')
              }
              if(this.info.User.SalesPlan > 0 && this.info.User.SalesFact != null){
                donePercent = (this.info.User.SalesFact / this.info.User.SalesPlan)*100;
                tooltip.push('Выполнено: ' +donePercent.toFixed(2)+ '%');
              }
              display.reverse();
              return {
                Display: display.join(' / ') + (donePercent != null ? ' (' + donePercent.toFixed(0) + '%)' : ''),
                Tooltip: tooltip.join(',<br>')
              }
            }*/
            LevelInProjectIcon() {
                switch(this.info.User.LevelInProject){
                    case 1:
                        return "/Content/dist/image_svg.svg?#User2";
                        break;
                    case 2:
                        break;
                    case 3:
                        break;
                    case 4:
                        break;
                }
            }
        },

        methods: {
            getLevelIconClass(level) {
                switch(level) {
                    case UserLevelCode.Bronze:
                    case UserLevelCode.GradeB:
                        return 'levelinproject-icon-bronze';
                    case UserLevelCode.Silver:
                    case UserLevelCode.GradeA:
                        return 'levelinproject-icon-silver';
                    case UserLevelCode.Gold:
                    case UserLevelCode.GradeS:
                        return 'levelinproject-icon-gold';
                    case UserLevelCode.Platina:
                        return 'levelinproject-icon-platinum';
                }
            },

            getLevelName(level) {
                switch(level) {
                    case UserLevelCode.Bronze:
                        return 'Бронза';
                    case UserLevelCode.Silver:
                        return 'Серебро';
                    case UserLevelCode.Gold:
                        return 'Золото';
                    case UserLevelCode.Platina:
                        return 'Платина';
                    case UserLevelCode.GradeB:
                        return 'Грейд B';
                    case UserLevelCode.GradeA:
                        return 'Грейд A';
                    case UserLevelCode.GradeS:
                        return 'Грейд S';
                    default:
                        return '';
                }
            },

            onUserProjectChange(){
                let vm = this;
                localStorage.setItem('selectedProjectId', vm.newProjectId);
                location.reload();
            },

            saveSecondsProgress(){
                return;
                // временно отключаем
                if(this.totalSeconds > 0) {
                    this.callApiWrapper(backendApi.saveSecondsProgress(this.totalSeconds));
                }
            },

            onUserIdChange: _.debounce(function () {
                let vm = this;

                if(!vm.userToChange.id){
                    vm.userToChange.found = null;
                    return;
                }

                vm.callApiWrapper(backendApi.checkUser(vm.userToChange.id)).then(function (resp) {
                    if (!resp.hasError && resp.data.Exists === true) {
                        vm.userToChange.fio = resp.data.UserFio;
                        vm.userToChange.found = true;
                        vm.userToChange.redirectUrl = resp.data.RedirectUrl;
                    } else {
                        vm.userToChange.fio = null;
                        vm.userToChange.found = false;
                        vm.userToChange.redirectUrl = null;
                    }
                });

            }, 300),

            onChangeUser(){
                let vm = this;

                vm.callApiWrapper(backendApi.changeUser(vm.userToChange.id)).then(function (resp) {
                    if(!resp.hasError){

                        localStorage.setItem('loggedByUser', resp.data.CheckData);

                        localStorage.removeItem(tokenKey);
                        sessionStorage.removeItem(tokenKey);
                        localStorage.removeItem('cart');
                        localStorage.removeItem('usersComplexFilter');
                        sessionStorage.removeItem('selectedProjectId');
                        localStorage.removeItem('selectedProjectId');

                        localStorage.setItem(tokenKey, JSON.stringify({
                            access_token: resp.data.Token
                        }));

                        localStorage.setItem('firstLogin', 'true');

                        let redirectUrl = '/';
                        // if(vm.userToChange.redirectUrl && vm.userToChange.redirectUrl !== '/'){
                        //     redirectUrl = (vm.userToChange.redirectUrl !== 'demo.promoclub.online' ? 'https://' : 'http://') + vm.userToChange.redirectUrl;
                        // }
                        location.href = redirectUrl;
                    }
                    else{
                        UI.toastr.error('Ошибка при смене пользователя');
                    }

                    vm.$refs['ppChangeUser'].close();
                });
            },

            onReturnFromUser() {
                let vm = this;

                let loggedByUser = localStorage.getItem('loggedByUser');
                localStorage.removeItem('loggedByUser');

                vm.callApiWrapper(backendApi.returnToUser(loggedByUser)).then(function (resp) {
                    if (!resp.hasError) {

                        localStorage.removeItem(tokenKey);
                        sessionStorage.removeItem(tokenKey);
                        localStorage.removeItem('cart');
                        localStorage.removeItem('usersComplexFilter');

                        localStorage.setItem(tokenKey, JSON.stringify({
                            access_token: resp.data.Token
                        }));

                        location.href = '/';
                    }
                    else {
                        UI.toastr.error('Внутренняя ошибка сервера');
                        location.href = '/login';
                    }
                });
            },

            fileExtensionIsHtml(filename) {
                return filename.endsWith('.html');
            },

            saveAgreements(){
                let vm = this;

                vm.callApiWrapper(backendApi.profileSaveAgreements(vm.TermsConfirmed, vm.NotificationsEnabled, vm.PersonalDataEditingAccept)).then(function (resp) {
                    if(!resp.hasError){
                        vm.info.User.TermsConfirmed = true;
                        vm.$refs['ppAgreements'].close();
                        vm.processUserLogin();
                    }
                    else{
                        UI.toastr.error('Ошибка при сохранении');
                    }
                });

            },

            appElementClick() {
                this.profileMenuOpen = false;
            },

            logOut() {
                let vm = this;
                let headers = {};
                let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'))
                if(tokenInfo){
                    headers.Authorization = "bearer " + tokenInfo.access_token
                }

                $.ajax({
                    type: 'POST',
                    url: config.apiUrl + '/api/account/logout',
                    headers: headers,
                    success: function () {
                        localStorage.removeItem('tokenInfo');
                        sessionStorage.removeItem('tokenInfo');
                        vm.$router.push('/login');
                    },
                    error: function (data, e, a) {
                        console.info('logOut fail -> data, e, a', data, e, a);
                    }
                });

                // localStorage.removeItem('tokenInfo');
                // sessionStorage.removeItem('tokenInfo');
                // this.$router.push('/login')
            },

            toggleMenu() {
                this.menuCollapsed = !this.menuCollapsed;
                this.$emit('menu-toggled')
            },

            toggleMenuMob() {
                this.menuMobShow = !this.menuMobShow;
                //this.$emit('menu-toggled')
            },

            onShowModal(modal) {
                this.$nextTick(() => {

                    this.$refs[modal].show();

                });
            },

            refreshMenuData() {
                this.$refs.menu.refreshMenuData();
            },

            refreshCart() {
                this.cartItemsCount = cart.getItemsCount();
            },

            userUpdated() {
                this.loadSummary();
            },

            getUserNameToDisplay() {
                let user = this.info.User;
                if (!user) {
                    return "";
                }

                let fio = `${user.LastName} ${user.FirstName}`.trim(); //${user.MiddleName ? user.MiddleName : ''}
                return fio ? fio : user.UserName;
            },

            getUserBonusToDisplay(type, short) {
                let user = this.info.User;
                var val = type === 'active' ? user.ActiveBalanceWithOrders.toFixed(0) : user.PotentialBalance.toFixed(0);
                return (short ? '' : (type === 'active' ? 'Доступно ' : 'Всего ')) + val + (short ? '' : CM.methods.get_text_ending(val, [' балл',' балла',' баллов']));
            },

            loadSummary() {
                let vm = this;
                 return this.callApiWrapper(backendApi.summaryInfo(localStorage.getItem('selectedProjectId'))).then(function (resp) {
                    if (!resp.hasError && resp.data) {
                        //console.info('resp.data', resp.data);
                        vm.info = Object.assign({}, resp.data);
                        vm.info.FeedbackSettings = JSON.parse(vm.info.FeedbackSettings || '{}');

                        //if (resp.data.User && resp.data.User.ProjectId) {
                            localStorage.setItem('selectedProjectId', resp.data.SelectedProject.Id);
                        //}

                        vm.selectedProject = resp.data.SelectedProject;//Projects.find(x => x.Id === resp.data.SelectedProjectId);
                        vm.newProjectId = resp.data.SelectedProject.Id;
                        if (vm.selectedProject.MenuColor)
                            vm.menuColor = vm.selectedProject.MenuColor;
                        else vm.menuColor = '#8198AE';
                        //vm.about.text = resp.data.AboutText ? resp.data.AboutText : '';
                        //vm.about.origin = resp.data.AboutText ? resp.data.AboutText : '';
                        vm.firstLaunchItems = resp.data.FirstLaunch;


                        if(localStorage.getItem('loggedByUser') != null){
                            vm.loggedByUser = true;
                        }

                        vm.processUserLogin();
                    }
                });
            },

            processUserLogin(){
                let vm = this;

                if (!vm.loggedByUser && vm.info && !vm.info.User.TermsConfirmed) {
                    // показываем окно с галочками о согласии
                    vm.$refs['ppAgreements'].show();
                }
                else if (!vm.loggedByUser && vm.info && !vm.info.User.EmailConfirmed){
                    vm.confirmation.email = vm.info.User.Email;
                    vm.$refs['ppEmailConfirmed'].show();

                    window.setTimeout(function(){
                        // если div удалили вручную
                        let $emailConfirmedDiv = $('[name=ppEmailConfirmed]');
                        if(!$emailConfirmedDiv.length){
                            location.href='/';
                        }
                    }, 50);
                }
                else {
                    // проверяем версию бандла (только на продакшене)
                    if(config.mode === 'prod' && window['BundleVersion'] != vm.info.BundleVersion){
                        location.reload();
                    }

                    let mainRole = vm.info.User.MainRole;
                    let dynamicRole = vm.info.User.DynamicRole;
                    let firstLogin = localStorage.getItem('firstLogin');

                    if (mainRole !== 'administrators') {
                        // проверяем доступ к странице
                        let pageClaim;
                        switch (vm.$route.name) {
                            case 'materials':
                                pageClaim = vm.claimEnums.materialsPage;
                                break;
                            case 'materialEdit':
                            case 'folderEdit':
                            case 'questionEdit':
                                pageClaim = vm.claimEnums.materialCreate;
                                break;
                            case 'motivation':
                                pageClaim = vm.claimEnums.motivationPage;
                                break;
                            case 'news':
                            case 'newsEdit':
                            case 'newsDetails':
                                pageClaim = vm.claimEnums.newsPage;
                                break;
                            case 'projects':
                            case 'projectEdit':
                            case 'trade-points':
                            case 'users':
                            case 'userEdit':
                            case 'roles':
                                pageClaim = vm.claimEnums.projectPage;
                                break;
                            case 'rewardEdit':
                            case 'rewardFolderEdit':
                                pageClaim = vm.claimEnums.rewardsEdit;
                                break;
                            case 'rating':
                                pageClaim = vm.claimEnums.ratingPage;
                                break;
                            case 'reports':
                            case 'reportDetails':
                                pageClaim = vm.claimEnums.reportsPage;
                                break;
                            case 'spend-bonuses':
                                pageClaim = vm.claimEnums.spendBonusesPage;
                                break;
                            case 'analytics':
                                pageClaim = vm.claimEnums.analyticsPage;
                                break;
                            case 'sku':
                            case 'skuDetails':
                                pageClaim = vm.claimEnums.skuPage;
                                break;
                            case 'skuEdit':
                            case 'skuFolderEdit':
                                pageClaim = vm.claimEnums.skuCreate;
                                break;
                            case 'cart':
                                pageClaim = vm.claimEnums.bonusSpend;
                                break;
                            case 'orders':
                                pageClaim = vm.claimEnums.ordersPage;
                                break;
                            case 'sender':
                                pageClaim = vm.claimEnums.senderPage;
                                break;
                            case 'faq':
                                pageClaim = vm.claimEnums.faqPage;
                                break;
                            case 'tasks':
                                pageClaim = vm.claimEnums.tasksPage;
                                break;
                            case 'tasksEdit':
                                pageClaim = vm.claimEnums.tasksEdit;
                                break;
                        }

                        if(vm.info.User.IsDisabled && !['profile', 'cart', 'spend-bonuses', 'bonus-history'].some(x => x === vm.$route.name)){
                            vm.$router.push('/spend-bonuses');
                        }

                        // todo: уточнить условия и переделать
                        // не проверяем для стартовой страницы
                        if (vm.$route.path !== '/' && pageClaim !== undefined && dynamicRole.Claims.find(x => x.ClaimId === pageClaim) === undefined) {
                            vm.$router.push('/');
                            return;
                        }
                    }

                    if (firstLogin === 'true' && dynamicRole != null) {
                        localStorage.removeItem('firstLogin');
                        let mainPageClaim = dynamicRole.Claims.find(x => x.ClaimId === vm.claimEnums.mainPageSettings);
                        if (mainPageClaim !== undefined && mainPageClaim.Value) {
                            vm.$router.push(mainPageClaim.Value);
                        }
                    }

                    if(vm.firstLaunchItems && vm.firstLaunchItems.length){
                        //console.info('layout-> показываем firstItems');
                        vm.firstLaunchItemsShow = true;
                    }
                }
            },

            onActionsComplete(){
                return this.callApiWrapper(backendApi.firstActionsComplete());
            },

            requestConfirmationCode(){
                let vm = this;
                vm.confirmation.isSending = true;
                vm.callApiWrapper(backendApi.requestConfirmationCode()).then(function (resp) {
                    vm.confirmation.isSending = false;
                    if (resp.hasError) {
                        if(resp.status === 11 || resp.status === 12)
                        {
                            if(resp.status === 11){
                                vm.confirmation.errors.newemail = 'В указанной почте допущены ошибки. Введите правильный адрес.';
                            }
                            else{
                                vm.confirmation.errors.newemail = 'Нам не удается доставить сообщения на данный адрес. Пожалуйста, укажите правильный.';
                            }
                            vm.confirmation.state = 'newemail';
                            vm.confirmation.newemail = vm.confirmation.email;
                        }else{
                            UI.toastr.error('Ошибка во время отправки кода')
                        }

                        return;
                    }
                    if(resp.data.Value == null){
                        UI.toastr.error(resp.data.Message.Errors[0]);
                    }

                    vm.confirmation.state = 'code';
                });

            },

            onConfirmationCodeKeyUp() {
                let vm = this;
                let trimmedCode = $.trim(vm.confirmation.code.value);
                if(trimmedCode.length === 4){
                    vm.confirmation.code.disabled = true;

                    this.callApiWrapper(backendApi.checkConfirmationCode(trimmedCode)).then(function (resp) {
                        if (resp.hasError) {
                            UI.toastr.error('Ошибка во время проверки кода')
                        }
                        else {
                            if (resp.data === true) {
                                vm.confirmation.errors.code = null;
                                vm.confirmation.state = 'confirmed';
                                vm.info.User.TermsConfirmed = true;

                                setTimeout(function () {
                                    vm.$refs['ppEmailConfirmed'].close();
                                }, 1000);
                            } else {
                                vm.confirmation.errors.code = 'Не верный код';
                            }
                        }
                        vm.confirmation.code.disabled = false;
                    });
                }
            },

            onConfirmationShowNewEmail(){
                let vm = this;

                vm.confirmation.errors.newemail = null;
                vm.confirmation.showInfoText = false;
                vm.confirmation.state = 'newemail'
            },

            onConfirmationNewEmailSave(){
                let vm = this;

                this.$validator.validateAll('newemail').then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                        return;
                    }

                    vm.confirmation.errors.newemail = null;

                    vm.callApiWrapper(backendApi.requestConfirmationCode(_.trim(vm.confirmation.newemail))).then(function (resp) {
                        if (resp.hasError) {
                            if(resp.status === 8)
                            {
                                vm.confirmation.errors.newemail = 'Этот email уже используется';
                            }else if(resp.status === 11)
                            {
                                vm.confirmation.errors.newemail = 'В указанной почте допущены ошибки. Введите правильный адрес.';
                            }else if(resp.status === 12)
                            {
                                vm.confirmation.errors.newemail = 'Нам не удается доставить сообщения на данный адрес. Пожалуйста, укажите правильный.';
                            }else{
                                UI.toastr.error('Ошибка во время отправки кода')
                            }

                            return;
                        }
                        if(resp.data.Value == null){
                            UI.toastr.error(resp.data.Message.Errors[0]);
                        }

                        vm.confirmation.state = 'code';
                    });
                });
            },

            onShowRulesClick(){
                let vm = this;

                vm.$refs.ppRules.show();
                vm.$nextTick(() => {
                    if (vm.$refs.pdfViewRules)
                        vm.$refs.pdfViewRules.show(vm.info.RulesFile);
                    // vm.$nextTick(()=>{
                    //     vm.$refs.pdfViewRules.toggleFullScreen();
                    // });
                });
            },

            onShowPolicyClick(){
                let vm = this;

                vm.$refs.ppPolicy.show();
                vm.$nextTick(() => {
                    if (vm.$refs.pdfViewPolicy)
                        vm.$refs.pdfViewPolicy.show(vm.info.PolicyFile);
                    // vm.$nextTick(()=>{
                    //     vm.$refs.pdfViewPolicy.toggleFullScreen();
                    // });
                });
            }
        },

        mounted() {
            console.info('LAYOUT mounted, mode', config.mode);
            UI.blockUI('.login-page-bg', 'Загрузка...', { overlayCSS: { backgroundColor: '#fff', opacity: 1 }} );
            let vm = this;

            if(vm.$route.query.token && vm.$route.query.projectId){
                let tokenKey = "tokenInfo";
                localStorage.removeItem('cart');
                localStorage.removeItem('usersComplexFilter');
                localStorage.setItem(tokenKey, JSON.stringify({access_token: vm.$route.query.token}));
                localStorage.setItem('selectedProjectId', vm.$route.query.projectId);

                window.location = window.location.pathname;
            }

            vm.menuCollapsed = vm.appMenuCollapsed;

            this.loadSummary().then(function(){

                UI.unblockUI('.login-page-bg');

                let interval = window.setInterval(function () {
                    if (typeof jivo_api !== 'undefined') {

                        window.jivo_onOpen = function(){
                            let contactinfo = {
                                "name": vm.info.User.Fio,
                                "email": vm.info.User.Email,
                                "phone": vm.info.User.Phone
                            };
                            if (vm.info.selectedProject){
                                contactinfo.description = vm.info.selectedProject.ProjectName;
                            }

                            jivo_api.setContactInfo(contactinfo);
                        };

                        window.clearInterval(interval);
                    }
                }, 100);
            });

            this.cartItemsCount = cart.getItemsCount();

            let interval = setInterval(function(){
                vm.totalSeconds++;
            }, 1000);

            window.addEventListener("beforeunload", function (e) {
                vm.saveSecondsProgress();
            });

            let notIE = (document.documentMode === undefined),
                isChromium = window.chrome;

            let onFocus = function(){
                if(!vm.layoutActive){
                    return;
                }
                //console.info('onFocus')
                if(!interval) {
                    interval = setInterval(function () {
                        vm.totalSeconds++;
                    }, 1000);
                }
            };
            let onBlur = function () {
                if(!vm.layoutActive){
                    return;
                }
                //console.info('onBlur')
                vm.saveSecondsProgress();
                clearInterval(interval);
                interval = null;
                vm.totalSeconds = 0;
            }

            if (notIE && !isChromium) {
                $(window).on("focusin", onFocus).on("focusout", onBlur);
            } else {
                // checks for IE and Chromium versions
                if (window.addEventListener) {
                    window.addEventListener("focus", onFocus, false);
                    window.addEventListener("blur", onBlur, false);
                } else {
                    window.attachEvent("focus", onFocus);
                    window.attachEvent("blur", onBlur);
                }
            }

            // document.addEventListener('visibilitychange', function(){
            //     console.info(new Date(),', document.visibilityState', document.visibilityState);
            // })
        },

        destroyed(){
            console.info('LAYOUT destroyed');
            this.layoutActive = false;
        }
    }

</script>

<style scoped>
    .levelinproject-icon-size {
        height: 20px;
        width: 20px;
        margin-left: 5px;
    }

    .levelinproject {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>


// WEBPACK FOOTER //
// Content/src/views/shared/Layout.vue